import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ISingleFieldPopupInput {
  title: string;
  subtitle: string;
  icon: string;
  fieldName: string;
  isValRequired: boolean;
  cancelBtnVal?: string;
  submitBtnVal?: string;
}

@Component({
  selector: 'single-field-popup',
  templateUrl: './single-field-popup.component.html',
  styleUrls: ['./single-field-popup.component.scss'],
})
export class SingleFieldPopupComponent implements OnInit {
  form = new FormGroup({
    value: new FormControl(''),
  });

  constructor(
    private matDialog: MatDialogRef<SingleFieldPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISingleFieldPopupInput
  ) {}

  ngOnInit(): void {
    if (this.data.isValRequired) {
      this.form.controls.value.setValidators(Validators.required);
      this.form.controls.value.updateValueAndValidity();
    }
  }

  outputData() {
    this.matDialog.close(this.form.value.value);
  }

  onClickClose() {
    this.matDialog.close();
  }
}
